import './dayjs'
import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import './fontawesome'
import reportWebVitals from './reportWebVitals'
import i18n from './i18n'
import { I18nextProvider } from 'react-i18next'
import 'ag-grid-community/dist/styles/ag-grid.css'
import 'ag-grid-community/dist/styles/ag-theme-alpine.css'
import App from './App'
import { initSentry } from './sentry'

initSentry()

ReactDOM.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
